(function () {
    'use strict';

    angular.module('swif.framework')
        .factory('actionService', actionService);
    /**
     * @ngdoc service
     * @name swif.framework.actionService
     * @requires ng.service:$parse
     * @requires ng.service:$q
     * @requires ng.service:$location
     * @requires swif.framework.swifAvailableService
     * @requires swif.framework.dataService
     * @requires swif.framework.settingsService
     * @requires swif.framework.swifModal
     * @requires swif.framework.msgService
     *
     **/
    function actionService($parse, $q, $location, swifAvailableService, dataService, settings, swifModal, msgService) {
        'ngInject';
        var available = swifAvailableService;
        return {
            /**
             * @ngdoc method
             * @name preValidate
             * @methodOf swif.framework.actionService
             * @param {function} preValidate that return True/False or Promise wrapped boolean
             * @param {object} options {model: object, action: action}
             * @description
             * Call the action's prevalidate
             * @returns {Promise} True/False promise
             */
            preValidate: function (preValidate, options) {
                var action = options.action;
                if (_.isUndefined(action.copy) || action.copy === true) {
                    options.model = angular.copy(options.model);
                }
                var preValidated = true;
                if (preValidate) {
                    preValidated = preValidate(options);
                }
                return $q.when(preValidated);
            },
            /**
             * @ngdoc method
             * @name dispatch
             * @methodOf swif.framework.actionService
             * @description
             * This call the action's prevalidate and wrap the results as a promise
             * @returns {Promise} True/False promise
             */
            dispatch: function (contentType, action, model, options) {
                var self = this;
                if (model === undefined) {
                    model = {}; //keep track of your data !
                } else {
                    if (_.isUndefined(action.copy) || action.copy === true) {
                        model = angular.copy(model);
                    }
                }
                if (options === undefined) {
                    options = {};
                }
                var prevalidate_data = {
                    action: action,
                    model: model
                };
                if (action.modal) {
                    var preModalPromise;
                    var ref = {action: action, model: model};
                    if (options.preModal) {
                        preModalPromise = options.preModal(ref);
                        if (!preModalPromise) {
                            preModalPromise = $q.when(ref);
                        }
                    } else {
                        preModalPromise = $q.when(ref);
                    }
                    preModalPromise.then(function (ref) {
                        action = ref.action;
                        model = ref.model;
                        var modalConfig = angular.copy(action.modal);
                        modalConfig.contentType = contentType;
                        modalConfig.action = action;
                        modalConfig.model = model;
                        modalConfig.preValidate = options.preValidate; //done by modal
                        modalConfig.options = options;
                        swifModal.open(modalConfig);
                    });
                } else if (action.http) {
                    self.preValidate(options.preValidate, prevalidate_data).then(function (preValidated) {
                        if (preValidated) {
                            self._ajaxAction(contentType, prevalidate_data.action, prevalidate_data.model, options.callback);
                        }
                    });
                } else if (action.link) {
                    self.preValidate(options.preValidate, prevalidate_data).then(function (preValidated) {
                        if (preValidated) {
                            self._goTo(prevalidate_data.action.link, prevalidate_data.model);
                        }
                    });
                } else {
                    self.preValidate(options.preValidate, prevalidate_data).then(function (preValidated) {
                        if (preValidated && options.callback !== undefined) {
                            options.callback(null, prevalidate_data);
                        }
                    });
                }
            },
            _goTo: function (location, context) {
                var finalLocaltion = angular.copy(location);
                if(context) {
                    var reg = /:([a-zA-Z0-9_]+)/g;
                    var params = location.match(reg);
                    if(params) {
                        _.forEach(params, function (item) {
                            var field = item.replace(':', '');
                            finalLocaltion = finalLocaltion.replace(item, $parse(field)(context) || '');
                        });
                    }
                }
                $location.path(finalLocaltion);
            },
            _ajaxAction: function (contentType, action, model, callback) {
                var loading = {};
                msgService.loading(loading);
                var self = this;
                var promise = self._callDataService(contentType, action, model);
                if (callback !== undefined) {
                    return promise.then(function (result) {
                        msgService.loading(loading, 'ok');
                        return callback(null, {
                            action: action,
                            result: result,
                            model: model
                        });
                    }, function (error) {
                        msgService.loading(loading, 'ko');
                        msgService.addError(error);
                        return callback(error);
                    });
                } else {
                    return promise.then(function (data) {
                        console.log('action success but no callback');
                        msgService.loading(loading, 'ok');
                    }, function (error) {
                        msgService.addError(error);
                        msgService.loading(loading, 'ko');
                    });
                }
            },
            _callDataService: function (contentType, action, data) {
                return dataService.dispatchAction(contentType, action, data);
            },
            isAvailable: function (action, model) {
                var context = {o: model};
                var actions = {};
                if (model) {
                    _.forEach(model.actions, function (action) {
                        actions[action] = true;
                    });
                }
                context.actions = actions;
                return available.isAvailable(action, context);
            },
            getActions: function (contentType, categories, model, isAvailable) {
                var self = this;
                var actions = [];
                var typeConfig = settings.app.contentTypes[contentType];
                if (typeConfig) {
                    var actionsByCat = typeConfig.actions;
                    if (actionsByCat) {
                        _.forEach(categories.split(','), function (category) {
                            if (actionsByCat[category]) {
                                var action;
                                for (var i = 0; i < actionsByCat[category].length; i++) {
                                    action = actionsByCat[category][i];
                                    if (isAvailable || action.visible && self.isAvailable(action, model)){
                                        actions.push(action);
                                    }
                                }
                            }
                        });
                    }
                }
                return actions;
            },
            getActionById: function (contentType, categories, id, model, isAvailable) {
                var actions = this.getActions(contentType, categories, model, isAvailable);
                var result;
                _.forEach(actions, function (action) {
                    if (action.id === id) {
                        result = action;
                    }
                });
                return result;
            },
            updateActions: function (model) {
                if (model) {
                    if (!model.__updateActions) {
                        model.__updateActions = true;
                    } else if (model.__updateActions === true){
                        model.__updateActions = 1;
                    } else if (model.__updateActions === 1){
                        model.__updateActions = true;
                    }
                }
            }
        };
    }

})();
